import PropTypes from "prop-types";

import styles from "./styles.module.css";

const SignupBoxItem = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconWrap}>{data.icon}</div>
      <span className={styles.text} dangerouslySetInnerHTML={{ __html: data.text }} />
    </div>
  );
};

SignupBoxItem.propTypes = {
  data: PropTypes.object,
};

export default SignupBoxItem;
